"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Rx_1 = require("rxjs/Rx");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var FilterGroup = /** @class */ (function () {
    function FilterGroup() {
        this._filterItems = [];
    }
    Object.defineProperty(FilterGroup.prototype, "filterItems", {
        get: function () {
            return this._filterItems;
        },
        set: function (filterItems) {
            this._filterItems = filterItems;
        },
        enumerable: true,
        configurable: true
    });
    FilterGroup.prototype.validate = function (onlyThoseRequiringValidation) {
        if (onlyThoseRequiringValidation === void 0) { onlyThoseRequiringValidation = false; }
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(onlyThoseRequiringValidation);
        this.filterItems.forEach(function (filterItem) {
            if (onlyThoseRequiringValidation === false || onlyThoseRequiringValidation === true && filterItem.requiresCriterionValidation()) {
                filterItem.validate();
            }
        });
    };
    FilterGroup.prototype.isValid = function () {
        var itemValidationObservables = [];
        itemValidationObservables = this.filterItems
            .map(function (filterItem) {
            return filterItem.criterionValidator.isValid;
        });
        return Rx_1.Observable.combineLatest(itemValidationObservables);
    };
    FilterGroup.prototype.isTemporary = function () {
        return this.filterItems.every(function (filterItem) {
            return filterItem.isTemporary();
        });
    };
    return FilterGroup;
}());
exports.FilterGroup = FilterGroup;
//# sourceMappingURL=filter-group.js.map